import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CanonicalService {
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  constructor(@Inject(DOCUMENT) private dom) {}
  setCanonicalURL(url?: string) {
    if (this.isBrowser) {
    const canURL = url === undefined ? this.dom.URL : url;
    // eslint-disable-next-line no-extra-boolean-cast
    const link: HTMLLinkElement = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.dom.head.appendChild(link);
    link.setAttribute('href', canURL);
  }
  }
}
